import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Analytics Utility
 * Provides a unified interface for tracking page views and user events.
 * Can be easily integrated with PostHog, Google Analytics, Mixpanel, etc.
 */

class Analytics {
  private isInitialized = false;

  init() {
    if (this.isInitialized) return;
    // Implement standard init logic here (e.g., posthog.init())
    console.log('[Analytics] Initialized');
    this.isInitialized = true;
  }

  trackPageView(path: string) {
    if (!this.isInitialized) this.init();
    // Implement standard page view logic here (e.g., posthog.capture('$pageview'))
    console.log(`[Analytics] Page View: ${path}`);
  }

  trackEvent(eventName: string, properties?: Record<string, any>) {
    if (!this.isInitialized) this.init();
    // Implement custom event tracking here
    console.log(`[Analytics] Event: ${eventName}`, properties);
  }

  identify(userId: string, traits?: Record<string, any>) {
    if (!this.isInitialized) this.init();
    // Implement user identification logic here
    console.log(`[Analytics] Identified User: ${userId}`, traits);
  }
}

export const analytics = new Analytics();

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    analytics.trackPageView(location.pathname + location.search);
  }, [location]);
};
